import React from "react";
import styles from "./HamperContents.module.css";
import myStyles from "../../Products/SpecificProduct/SpecificProduct.module.css";
import useHamperStore from "../../../Stores/useHamperStore";
import { handleImgError } from "../../Shared/ImageError";
import HamperProduct from "./HamperProduct";
import Collapse from "../../Shared/Collapsable/Collapse";

function HamperContents({ openContents }) {
  const { selectedHamper, buildProductSelectionSummary, isHamperReadyToOrder } =
    useHamperStore();

  return (
    <div className={styles.HamperContents}>
      <Collapse title="Hamper Contents" forceOpen={openContents}>
        {selectedHamper != null && selectedHamper?.Products != null ? (
          <div className={styles.ProductGrid}>
            {selectedHamper.Products.map((prod, index) => (
              <HamperProduct 
              productId={prod.Product.Id} 
              key={index} 
              evaluateSelection={openContents}/>
            ))}
          </div>
        ) : null}
      </Collapse>
    </div>
    // </div>
  );
}

export default HamperContents;
